export default () => ({

  globalRingtones: [],
  realmRingtones: [],

  permissions: [],
  roles: []

})
